import { defineMessages } from '@jutro/locale';

export default defineMessages({
    updatedCoverages: {
        id: 'ml.endorsement.common.MLCoveragePage.Updated Coverages',
        defaultMessage: 'Updated Coverages',
    },
    paNamedExcludeAllSelectedMessage: {
        id: 'ml.endorsement.common.MLCoveragePage.paNamedExcludeAllSelectedMessage',
        defaultMessage: '{vehicleName} - All drivers have been checked for Named Driver Exclusion. Need to uncheck at least one driver or remove Named Driver Exclusion and comprehensive and collision coverages.'
    },
    paNamedExcludeNoneSelectedMessage: {
        id: 'ml.endorsement.common.MLCoveragePage.paNamedExcludeNoneSelectedMessage',
        defaultMessage: '{vehicleName} - Must select a driver to exclude  or remove Named Driver Exclusion.'
    },
    suspendedLiability: {
        id: 'ml.endorsement.common.MLCoveragePage.suspendedLiability',
        defaultMessage: '<p><strong>Warning:</strong>  If you suspend liability, the following coverages will also be suspended:  Bodily Injury, Property Damage, Combined Single Limit, Uninsured Motorist, Underinsured Motorist, Uninsured and Underinsured Bodily Injury, Uninsured Property Damage, Personal Injury Protection and Medical coverage.</p><br></br><p>In an accident, the vehicle owner and driver could be held personally liable for any damages.  The vehicle may be considered uninsured and may be subject to penalty under the state’s motor vehicle laws.</p>'
    },
    functionalReplacementCostWarning: {
        id: 'ml.endorsement.common.MLCoveragePage.Building Property Loss Settlement option...',
        defaultMessage: 'Building Property Loss Settlement option is not valid as both Guaranteed and Functional have been selected. Changes are required to either the Property Details or Coverages.'
    },
    savingPolicyChange: {
        id: 'ml.endorsement.common.MLCoveragePage.Saving policy change',
        defaultMessage: 'Saving policy change'
    },
    ITVAck: {
        id: 'ml.endorsement.common.MLCoveragePage.ITVAck',
        defaultMessage: 'The updated dwelling coverage limit is below the estimated replacement cost for the dwelling.  At this dwelling coverage amount, the insured may not have enough coverage to rebuild their home in the event of a total loss.  By clicking the CONTINUE button, the insured is acknowledging they do not want to insure their home for the full estimated cost to rebuild.'
    },
    invalidQuote: {
        id: 'ml.endorsement.common.MLCoveragePage.Invalid Quote Generated',
        defaultMessage: 'Invalid Quote Generated'
    },
    invalidOptions: {
        id: 'ml.endorsement.common.MLCoveragePage.Sorry, but options picked are not valid, try different option.',
        defaultMessage: 'Sorry, but options picked are not valid, try different option.'
    },
    perTermLabelYear: {
        id: 'ml.endorsement.common.MLCoveragePage.perTermLabelYear',
        defaultMessage: 'year'
    },
    perTermLabel6Month: {
        id: 'ml.endorsement.common.MLCoveragePage.perTermLabel6Month',
        defaultMessage: '6 months'
    },
    perTermLabel7day: {
        id: 'ml.endorsement.common.MLCoveragePage.perTermLabel7day',
        defaultMessage: '7 days'
    },
    requote:{
        id: 'ml.endorsement.common.MLCoveragePage.REQUOTE',
        defaultMessage: 'REQUOTE'
    },
    continue:{
        id: 'ml.endorsement.common.MLCoveragePage.CONTINUE',
        defaultMessage: 'CONTINUE'
    },
    makeChangesHeader: {
        id: 'ml.endorsement.common.MLCoveragePage.Make Changes',
        defaultMessage: 'Make Changes'
    },
    coverageTotal: {
        id: "ml.endorsement.common.MLCoveragePage.Coverage Total",
        defaultMessage: "Coverage Total"
    },
    nextDesc: {
        id: "ml.endorsement.common.MLCoveragePage.nextDesc",
        defaultMessage: "We'll check if {additionalChangesNeeded} next"
    },
    additionalChangesNeeded: {
        id: "ml.endorsement.common.MLCoveragePage.additional changes are needed",
        defaultMessage: "additional changes are needed"
    },
    addressIssues: {
        id: "ml.endorsement.common.MLCoveragePage.Please address the following issues:",
        defaultMessage: "Please address the following issues:"
    },
    navigateToDiffScreen: {
        id: 'ml.endorsement.common.MLCoveragePage.navigateToDiffScreen',
        defaultMessage: 'To fix the error(s), you may need to navigate to a different screen from the <a>Make Changes</a> main screen.'
    },
    thirdPartyAlertMessage: {
        id: 'ml.endorsement.common.MLCoveragePage.thirdPartyAlertMessage',
        defaultMessage: 'Advise the customer they will receive a Notice of Right to Authorize Another Individual form to complete and return. The interested party will be added to the policy once the form has been signed and returned.'
    },
    unableToProceedCallAgency: {
        id: 'ml.endorsement.common.policyChangeSummary.unableToProceedCallAgency',
        defaultMessage: '{message1} {message2}'
    },
    conflictsPriorChange: {
        id: 'ml.endorsement.common.policyChangeSummary.Some automatic changes have occurred',
        defaultMessage: 'You are unable to proceed as information conflicts with a prior change.'
    },
    callAgency: {
        id: 'ml.endorsement.common.policyChangeSummary.Some automatic changes have occurred',
        defaultMessage: 'To resolve, please chat or call Agency Resource Center at 1-800-255-0332.'
    },
    windstormHailDeductibleBumpedWarning: {
        id: 'ml.endorsement.common.MLCoveragePage.WindstormHailDeductibleBumped',
        defaultMessage: 'The Windstorm or Hail Deductible was updated to the minimum required deductible.'
    },
    roofLossSettlementBumpedWarning: {
        id: 'ml.endorsement.common.MLCoveragePage.RoofLossSettlementBumped',
        defaultMessage: 'Roof Loss Settlement was updated to Scheduled Roof as required.'
    },
    allOtherPerilBumpedWarning: {
        id: 'ml.endorsement.common.MLCoveragePage.AllOtherPerilBumped',
        defaultMessage: 'The All Other Perils deductible was updated to the minimum required deductible.'
    },
    grcAvailableBumpedWarning: {
        id: 'ml.endorsement.common.MLCoveragePage.GRCAvailableBumped',
        defaultMessage: 'Blanket Property and/or Guaranteed Rebuild is not available for this risk and the Building Property Loss Settlement and building code coverage have been updated.'
    },
    fortifiedRoofWarning: {
        id: 'ml.endorsement.common.MLCoveragePage.fortifiedRoofWarning',
        defaultMessage: 'FORTIFIED Roof Upgrade coverage has been removed. The coverage can be added back only within 60 days from Term Start date.'
    }
});
